import { FormControl } from "@angular/forms";

enum FILE_TYPES {
  csv = 'csv',
  xls = 'xls',
  xlsx = 'xlsx',
}

const USER_IMPORT_MIME_TYPE = {
  [FILE_TYPES.csv]: 'text/csv',
  [FILE_TYPES.xls]: 'application/vnd.ms-excel',
  [FILE_TYPES.xlsx]: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

const USER_IMPORT_MIME_TYPES: string[] = [
  'text/csv',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

export const MIME_TYPE_EXCEL_ACCEPT: string = USER_IMPORT_MIME_TYPES.join(', ');

enum SizeUnit {
  Bytes = 'Bytes',
  KB = 'KB',
  MB = 'MB',
}

type typeFileTypes = FILE_TYPES;

type MAX_FILE_SIZE_BY_TYPE = {
  [key in FILE_TYPES]: number;
};

interface IMapHeaderSelectionsForStepThree {
  control: FormControl;
}

interface IUserImportUploadSettings {
  uploadedFile: File;
  includeHeaders: boolean;
  columnSeperatorValue: string;
  valueSeperatorValue: string;
  fileType: any;
}

interface IMappings {
  userProp: string; sociuuProp: ISociuuFields, state: boolean, index: number, internalMapping?: boolean;
}

interface ISociuuFields{
  key: string;
  value: string;
}

interface IImportSettings {
  existing_users: existingUsersSettings;
  user_group: addUsergroupSettings;
  remove_existing_users: boolean;
}

interface IErrorsHashMap {
  [key: number]: {
    [key: number]: string;
  }
}

interface IPostAPIRequest {
  sociuu_columns: string[];
  settings: {
    sociuu_user_fields_mappings: Array<Array<string>>;
    existing_users: existingUsersSettings;
    user_group: addUsergroupSettings;
    remove_existing_users: boolean;
    user_dept_as_usergroup: boolean;
    user_file_contains_headers: boolean;
    column_separator?: string;
    value_separator?: string;
  };
  rows: (string | number)[][];
}

interface IDryRunResponse {
  total_count: number;
  created: number;
  updated: number;
  skipped: number;
  errors: number;
  removed: number;
  error_file: string;
  settings?: any;
}

type existingUsersSettings = "skip_users" | "update_users" | "replace_users";
type addUsergroupSettings = "add_usergroups" | "replace_usergroups";

export {
  FILE_TYPES,
  SizeUnit,
  typeFileTypes,
  MAX_FILE_SIZE_BY_TYPE,
  IUserImportUploadSettings,
  IMapHeaderSelectionsForStepThree,
  USER_IMPORT_MIME_TYPE,
  USER_IMPORT_MIME_TYPES,
  IMappings,
  ISociuuFields,
  IImportSettings,
  IErrorsHashMap,
  IPostAPIRequest,
  addUsergroupSettings,
  existingUsersSettings,
  IDryRunResponse,
}

